import {NavLink} from 'react-router-dom';
import {cn} from '@aiw/ui';
import {useT} from '../lib/i18n';

export function WebsiteNav(){
 const {t}=useT();
 const items=[['/website','website.nav.overview'],['/price-my-floor','website.nav.pricing'],['/marketing','website.nav.marketing'],['/showcase','website.nav.showcase']] as const;
 return <nav aria-label={t('website.nav.label')} className="mb-4 flex gap-1 overflow-x-auto rounded-lg border bg-card p-1">{items.map(([to,id])=><NavLink key={to} to={to} end={to==='/website'} className={({isActive})=>cn('min-h-9 shrink-0 rounded-md px-3 py-2 text-sm text-muted-foreground hover:bg-muted hover:text-foreground',isActive&&'bg-accent font-medium text-accent-foreground')}>{t(id)}</NavLink>)}</nav>;
}

export function WebsiteSection(){return <><WebsiteNav/><Outlet/></>;}
import {Outlet} from 'react-router-dom';
